import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import Conversation from '../ConversationItem';
import {List} from 'immutable';
import DateTime from '/chat/src/common/js/lib/DateTime';
import style from './style.scss';
import Header from '../Header'
import CustomizationModel from '/chat/src/redux/model/customization/model';

class ConversationsList extends Component {
    render() {
        const {language} = this.props

        let conversationsList = this.conversationsMaptoList();
        let {unresolved, resolved} = this.groupConversationsByResolvedStatus(conversationsList);
        unresolved = unresolved.sort(this.orderByLatestEntry);
        resolved = resolved.sort(this.orderByLatestEntry);

        const unresolvedC = unresolved.map((conversation) => {
            return <Conversation conversation={conversation} />;
        });
        const resolvedC = resolved.map((conversation) => {
            return <Conversation conversation={conversation} />;
        });



        return (
            <div className={style.ConversationsList}>
                {unresolvedC.size !== 0 &&(
                    <div>
                    <div className={style.ConversationSeparation}>{language.get('CurrentConversations')}</div>
                    {unresolvedC.toJS()}
                    </div>
                )}
                {resolvedC.size !== 0 &&(
                    <div>
                    <div className={style.ConversationSeparation}>{language.get('PreviousConversations')}</div>
                    {resolvedC.toJS()}
                    </div>
                )}
            </div>
        );
    }

    conversationsMaptoList(){
        const conversations = this.props.conversations;
        let conversationsList = List();

        conversations.forEach((conversation) => {
            conversationsList = conversationsList.push(conversation);
        });

        return conversationsList;
    }

    groupConversationsByResolvedStatus(conversations) {
        const unresolved = conversations.filter(conversation => !conversation.get('is_resolved'));
        const resolved = conversations.filter(conversation => conversation.get('is_resolved'));

        return {
            unresolved: unresolved,
            resolved: resolved
        };
    }

    orderByLatestEntry(cA, cB) {
        const lastEntryA = cA.getIn(['entries', -1, 'date_created'])
        const lastEntryB = cB.getIn(['entries', -1, 'date_created'])
        if(!lastEntryA) return 0;
        if(!lastEntryB) return 0;
        const timeA= DateTime.getTimestamp(lastEntryA);
        const timeB= DateTime.getTimestamp(lastEntryB);

        return timeB - timeA;
    }
}

function mapStateToProps(state) {
    return {
        language: CustomizationModel.getLanguage(state)
    }
}

export default connect(mapStateToProps)(ConversationsList);



// WEBPACK FOOTER //
// ./routes/Conversations/ConversationsList/index.js